import { FC } from "react";
import { IconProps } from "./types";

export const ArrowDownCircleFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zM6 13.175c0 .156.079.313.158.39l5.447 5.403a.605.605 0 0 0 .395.157c.04 0 .079-.02.118-.04.04-.019.08-.038.119-.038 0-.049.03-.067.072-.093.025-.015.056-.034.086-.064l5.447-5.402a.595.595 0 0 0 .158-.392c0-.039-.02-.078-.04-.117a.277.277 0 0 1-.039-.118c-.049 0-.067-.03-.093-.071a.44.44 0 0 0-.065-.085c0-.079-.079-.157-.158-.157-.079-.078-.158-.078-.237-.078-.04 0-.078.02-.118.039-.04.02-.079.04-.118.04 0 .048-.03.066-.072.091-.026.016-.056.035-.086.065l-4.421 4.384V5.423a.595.595 0 0 0-.158-.391.605.605 0 0 0-.395-.157c-.158 0-.316.078-.474.157a.596.596 0 0 0-.158.391v11.745l-4.42-4.385a.606.606 0 0 0-.395-.157.606.606 0 0 0-.395.157C6 12.861 6 13.018 6 13.175z"
      fill={fill}
    />
  </svg>
);
